/* 個別機能訓練に関する記録 */
import * as React from 'react';
import DateList from '../containers/DateList';
import { kirokuUserListHeader, UserSelectBody, Type } from './UserListField';
import * as PropTypes from 'prop-types';
import * as Header from '../constants/Header';
import 'react-bootstrap';
import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/kiroku.css';
import '../css/locomo.css';
import '../css/calendar.css';
import '../css/print.css';

interface UserSelectKirokuProps extends React.Props<{}> {
  moffAPI: any;
  moffAPIActions: any;
  headerActions?: any;
}

class UserSelectKiroku extends React.Component<UserSelectKirokuProps, {}> {
  static propTypes = {
    moffAPI: PropTypes.any.isRequired,
    moffAPIActions: PropTypes.any.isRequired,
  };

  componentWillMount() {
    document.title = '記録一覧(曜日別)';

    this.props.headerActions.setPage(Header.USER_SELECT_KIROKU);

    // Action
    this.props.moffAPIActions.getUsers();
  }

  render() {
    return (
      <div>
        <DateList />
        { // 
          (() => {
            if (this.props.moffAPI.Loaded) {
              return;
            }

            // ローディング中
            return <div><div id="loader" /><div id="loader_back" /></div>;
          })()
        }

        <div id="userlist">
          <table className="tblStyle01">
            <thead>
              <tr>
                {kirokuUserListHeader}
              </tr>
            </thead>
            <tbody>
            {(this.props.moffAPI.Loaded) ? 
              // ロードしたUserを表示.
              <UserSelectBody
                type={Type.Kiroku}
                users={this.props.moffAPI.result}
              /> 
             :
              // ロード中.
              (null)
            }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default UserSelectKiroku;



// WEBPACK FOOTER //
// ./src/components/UserSelectKiroku.tsx